import React from 'react';
import HamburgerMenu from '../global/menu';
import MayoLogo from '../assets/images/Mayo.png';
import AdminInsightsPanel from '../components/AdminInsightsPanel';
import StationChangeAlerts from '../components/StationChangeAlerts';
import InsightsScheduleCard from '../components/InsightsScheduleCard';
import PromptTemplateEditor from '../components/PromptTemplateEditor';
import '../global/styles.css';

function Admin({ userInfo, isAdmin = false, onLogout, onNavigate }) {

  // Allow admins OR editors to access this screen
  const hasAccess = isAdmin || userInfo?.is_editor || userInfo?.editor;

  if (!hasAccess) {
    return (
      <div className="container-center">
        <div className="card card-center">
          <h1 className="title">Access Denied</h1>
          <p className="subtitle">You need admin or editor permissions to access this area.</p>
          <button
            onClick={() => onNavigate('home')}
            className="btn btn-primary btn-full"
          >
            Return to Home
          </button>
        </div>
      </div>
    );
  }

  const handleDownloadDEAForm = () => {
    const link = document.createElement('a');
    link.href = '/dea-form-41.pdf';
    link.download = 'DEA Form 41.pdf';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Lucide React icons (commonly used, free, professional)
  const UsersIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="admin-icon">
      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="8.5" cy="7" r="4"/>
      <path d="M20 8v6M23 11h-6"/>
    </svg>
  );

  const ClipboardIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="admin-icon">
      <rect width="8" height="4" x="8" y="2" rx="1" ry="1"/>
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
      <path d="M12 11h4"/>
      <path d="M12 16h4"/>
      <path d="M8 11h.01"/>
      <path d="M8 16h.01"/>
    </svg>
  );

  const BarChartIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="admin-icon">
      <line x1="12" x2="12" y1="20" y2="10"/>
      <line x1="18" x2="18" y1="20" y2="4"/>
      <line x1="6" x2="6" y1="20" y2="16"/>
    </svg>
  );

  const DownloadIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="7,10 12,15 17,10"/>
      <line x1="12" x2="12" y1="15" y2="3"/>
    </svg>
  );

  const FileTextIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="admin-icon">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14,2 14,8 20,8"/>
      <line x1="16" x2="8" y1="13" y2="13"/>
      <line x1="16" x2="8" y1="17" y2="17"/>
      <line x1="10" x2="8" y1="9" y2="9"/>
    </svg>
  );

  const PackageIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="admin-icon">
      <path d="M16.5 9.4l-9-5.19"/>
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
      <polyline points="3.27,6.96 12,12.01 20.73,6.96"/>
      <line x1="12" x2="12" y1="22.08" y2="12"/>
    </svg>
  );

  const CalendarIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="admin-icon">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
      <line x1="16" y1="2" x2="16" y2="6"/>
      <line x1="8" y1="2" x2="8" y2="6"/>
      <line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  );

  const TruckIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="admin-icon">
      <rect x="1" y="3" width="15" height="13"/>
      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
      <circle cx="5.5" cy="18.5" r="2.5"/>
      <circle cx="18.5" cy="18.5" r="2.5"/>
    </svg>
  );

  const ClipboardCheckIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="admin-icon">
    <rect width="8" height="4" x="8" y="2" rx="1" ry="1"/>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
    <path d="m9 14 2 2 4-4"/>
  </svg>
);

  const GitMergeIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="admin-icon">
      <circle cx="18" cy="18" r="3"/>
      <circle cx="6" cy="6" r="3"/>
      <path d="M6 21V9a9 9 0 0 0 9 9"/>
    </svg>
  );

  const AlertIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="admin-icon">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/>
      <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  );

  return (
    <div className="container">
      <HamburgerMenu 
        isAdmin={isAdmin}
        onLogout={onLogout}
        onNavigate={onNavigate}
      />

      <div className="content">
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img
            src={MayoLogo}
            alt="Mayo Clinic"
            className="logo-location"
            style={{ marginBottom: '20px' }}
          />
          <h1 className="title">Admin Dashboard</h1>
          <p className="subtitle">
            Welcome {userInfo?.firstName}! Manage system administration tasks and generate reports.
          </p>
        </div>

        {/* Admin Menu Grid - FIXED WITH CSS CLASS */}
        <div className="admin-grid">
          {/* Manage Users */}
          <div className="card admin-card" style={{ textAlign: 'center' }}>
            <div style={{ color: '#0E3293', marginBottom: '20px' }}>
              <UsersIcon />
            </div>
            <h3 className="admin-title" style={{ 
              color: '#333', 
              fontSize: '18px', 
              fontWeight: '600',
              marginBottom: '15px'
            }}>
              Manage Users
            </h3>
            <p style={{
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.4',
              marginBottom: '25px'
            }}>
              Add, edit, and manage user accounts and permissions
            </p>
            <button 
              className="btn btn-primary btn-full"
              onClick={() => onNavigate('users')}
            >
              ACCESS USER MANAGEMENT
            </button>
          </div>

          {/* Chain Of Custody Report */}
          <div className="card admin-card" style={{ textAlign: 'center' }}>
            <div style={{ color: '#0E3293', marginBottom: '20px' }}>
              <ClipboardIcon />
            </div>
            <h3 className="admin-title" style={{ 
              color: '#333', 
              fontSize: '18px', 
              fontWeight: '600',
              marginBottom: '15px'
            }}>
              Chain Of Custody Report
            </h3>
            <p style={{
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.4',
              marginBottom: '25px'
            }}>
              Generate and view chain of custody reports for controlled substances
            </p>
            <button 
              className="btn btn-primary btn-full"
              onClick={() => onNavigate('chain-of-custody-report')}
            >
              ACCESS CHAIN OF CUSTODY
            </button>
          </div>

          {/* Provider Usage Report */}
          <div className="card admin-card" style={{ textAlign: 'center' }}>
            <div style={{ color: '#0E3293', marginBottom: '20px' }}>
              <BarChartIcon />
            </div>
            <h3 className="admin-title" style={{
              color: '#333',
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '15px'
            }}>
              Provider Usage Report
            </h3>
            <p style={{
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.4',
              marginBottom: '25px'
            }}>
              View provider usage statistics and medication consumption data
            </p>
            <button
              className="btn btn-primary btn-full"
              onClick={() => onNavigate('provider-usage-report')}
            >
              ACCESS USAGE REPORT
            </button>
          </div>

          {/* Station Inventory Report */}
          <div className="card admin-card" style={{ textAlign: 'center' }}>
            <div style={{ color: '#0E3293', marginBottom: '20px' }}>
              <PackageIcon />
            </div>
            <h3 className="admin-title" style={{
              color: '#333',
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '15px'
            }}>
              Station Inventory Report
            </h3>
            <p style={{
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.4',
              marginBottom: '25px'
            }}>
              View latest total quantities of medications from EMS Station inventory
            </p>
            <button
              className="btn btn-primary btn-full"
              onClick={() => onNavigate('master-inventory')}
            >
              ACCESS STATION INVENTORY
            </button>
          </div>

          {/* Daily Dashboard */}
          <div className="card admin-card" style={{ textAlign: 'center' }}>
            <div style={{ color: '#0E3293', marginBottom: '20px' }}>
              <CalendarIcon />
            </div>
            <h3 className="admin-title" style={{
              color: '#333',
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '15px'
            }}>
              Daily Dashboard
            </h3>
            <p style={{
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.4',
              marginBottom: '25px'
            }}>
              View today's inventory log activities for all ambulances with narcotics tracked
            </p>
            <button
              className="btn btn-primary btn-full"
              onClick={() => onNavigate('daily-dashboard-admin')}
            >
              ACCESS DAILY DASHBOARD
            </button>
          </div>

          {/* Mileage Report */}
          <div className="card admin-card" style={{ textAlign: 'center' }}>
            <div style={{ color: '#0E3293', marginBottom: '20px' }}>
              <TruckIcon />
            </div>
            <h3 className="admin-title" style={{
              color: '#333',
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '15px'
            }}>
              Mileage Report
            </h3>
            <p style={{
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.4',
              marginBottom: '25px'
            }}>
              Track ambulance mileage with odometer readings and Florida trip comparisons
            </p>
            <button
              className="btn btn-primary btn-full"
              onClick={() => onNavigate('mileage-report')}
            >
              ACCESS MILEAGE REPORT
            </button>
          </div>

         {/* Expiration Report */}
          <div className="card admin-card" style={{ textAlign: 'center' }}>
            <div style={{ color: '#0E3293', marginBottom: '20px' }}>
              <AlertIcon />
            </div>
            <h3 className="admin-title" style={{
              color: '#333',
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '15px'
            }}>
              Expiration Report
            </h3>
            <p style={{
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.4',
              marginBottom: '25px'
            }}>
              Monitor medication expiration dates with color-coded urgency alerts
            </p>
            <button
              className="btn btn-primary btn-full"
              onClick={() => onNavigate('expiration-report')}
            >
              ACCESS EXPIRATION REPORT
            </button>
          </div>

          {/* Truck Activity Report - ADD THIS HERE */}
          <div className="card admin-card" style={{ textAlign: 'center' }}>
            <div style={{ color: '#0E3293', marginBottom: '20px' }}>
              <ClipboardCheckIcon />
            </div>
            <h3 className="admin-title" style={{
              color: '#333',
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '15px'
            }}>
              Truck Activity Report
            </h3>
            <p style={{
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.4',
              marginBottom: '25px'
            }}>
              View check-in and check-out activity with signatures and crew details
            </p>
            <button
              className="btn btn-primary btn-full"
              onClick={() => onNavigate('truck-activity-report')}
            >
              ACCESS TRUCK ACTIVITY
            </button>
          </div>

          {/* Shift Reconciliation Report */}
          <div className="card admin-card" style={{ textAlign: 'center' }}>
            <div style={{ color: '#0E3293', marginBottom: '20px' }}>
              <GitMergeIcon />
            </div>
            <h3 className="admin-title" style={{
              color: '#333',
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '15px'
            }}>
              Shift Reconciliation
            </h3>
            <p style={{
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.4',
              marginBottom: '25px'
            }}>
              Match check-ins to check-outs and identify missing entries
            </p>
            <button
              className="btn btn-primary btn-full"
              onClick={() => onNavigate('shift-reconciliation-report')}
            >
              ACCESS RECONCILIATION
            </button>
          </div>

          {/* Non-Controlled Medications Report */}
          <div className="card admin-card" style={{ textAlign: 'center' }}>
            <div style={{ color: '#2e7d32', marginBottom: '20px' }}>
              <PackageIcon />
            </div>
            <h3 className="admin-title" style={{
              color: '#333',
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '15px'
            }}>
              Non-Controlled Medications
            </h3>
            <p style={{
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.4',
              marginBottom: '25px'
            }}>
              View activity summary and submission logs for non-controlled medications
            </p>
            <button
              className="btn btn-primary btn-full"
              onClick={() => onNavigate('non-controlled-report')}
              style={{ background: '#2e7d32', borderColor: '#2e7d32' }}
            >
              ACCESS NON-CONTROLLED REPORT
            </button>
          </div>
        </div>  {/* THIS IS THE CLOSING TAG FOR admin-grid */}

        {/* AI Insights Section */}
        <div style={{ width: '100%', maxWidth: '1000px', margin: '40px auto 0' }}>
          <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '24px', fontSize: '22px', color: '#333' }}>
            AI Compliance Insights
          </h2>
          <AdminInsightsPanel userInfo={userInfo} />
          <StationChangeAlerts userInfo={userInfo} />
          <InsightsScheduleCard />
          <PromptTemplateEditor userInfo={userInfo} />
        </div>

             {/* DEA Form Section */}
        <div className="card" style={{
          textAlign: 'center',
          maxWidth: '600px',
          margin: '0 auto'
        }}>
          <div style={{ color: '#0E3293', marginBottom: '20px' }}>
            <FileTextIcon />
          </div>
          <h3 className="section-title" style={{ marginBottom: '15px' }}>
            DEA Form 41
          </h3>
          <p className="subtitle" style={{ marginBottom: '30px' }}>
            Download the fillable DEA Form 41 for reporting destruction of controlled substances.
          </p>
          <button 
            className="btn btn-secondary btn-rounded"
            onClick={handleDownloadDEAForm}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              margin: '0 auto'
            }}
          >
            <DownloadIcon />
            Download DEA Form 41
          </button>
        </div>
      </div>

      <footer className="footer">
        <p className="text-small">
          Admin Dashboard - NarcoticTrack © 2025 NarcoticTrack Inventory System, LLC
        </p>
      </footer>
    </div>
  );
}

export default Admin;
